import { ArrowLeft } from "lucide-react";
import { Reveal, SectionHeading } from "../Reveal";
import { ServiceIcon } from "../ServiceIcon";

export const Services = ({ services, onRequest }) => (
  <section id="services" data-testid="services-section" className="py-24 relative">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <SectionHeading
          kicker="خدماتنا"
          title="كل ما تحتاجه سيارتك، في موقعك"
          desc="عشر خدمات متنقلة بمعدات احترافية وفنيين خبرة — بدون سطحة وبدون انتظار ورشة."
        />
      </Reveal>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-12">
        {services.map((s, i) => (
          <Reveal key={s.id} delay={(i % 3) * 0.08} className="h-full">
            <div
              data-testid={`service-card-${s.id}`}
              className="group relative h-full bg-[#121214] border border-[#28282D] rounded-xl p-6 hover:border-yellow-400/60 hover:-translate-y-1 transition-all duration-300 overflow-hidden"
            >
              <div className="absolute -top-10 -left-10 w-32 h-32 bg-yellow-400/5 rounded-full blur-2xl group-hover:bg-yellow-400/15 transition-colors duration-500" />
              <div className="relative">
                <div className="w-12 h-12 rounded-lg bg-yellow-400/10 border border-yellow-400/30 flex items-center justify-center mb-4 text-yellow-400 group-hover:bg-yellow-400 group-hover:text-black transition-colors duration-300">
                  <ServiceIcon name={s.icon} className="w-6 h-6" />
                </div>
                <h3 className="font-display text-xl font-bold text-white mb-2">{s.title}</h3>
                <p className="text-sm text-zinc-400 leading-relaxed mb-5">{s.desc}</p>
                <button
                  data-testid={`service-request-btn-${s.id}`}
                  onClick={() => onRequest({ service: s.title })}
                  className="text-yellow-400 text-sm font-semibold inline-flex items-center gap-1.5 hover:gap-2.5 transition-all duration-200"
                >
                  اطلب الخدمة
                  <ArrowLeft className="w-4 h-4" />
                </button>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
